import { Snackbar } from '@changegps/horizon-component-library';

import { useToastStore } from '../store';

export const SubscriptionsSnackbar = () => {
  const { toast, hideToast } = useToastStore();

  return (
    <Snackbar
      open={!!toast}
      notification={{
        id: 'snackbar',
        message: toast?.message ?? '',
        severity: toast?.severity,
      }}
      onClose={hideToast}
    />
  );
};
